import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
export let lastModified = undefined;
export let frontmatter = {
  "title": "Vercel",
  "description": "Vercel에서 Turborepo를 사용하는 방법을 알아봅니다."
};
export let structuredData = {
  "contents": [{
    "heading": "",
    "content": "Vercel의 Turborepo와의 제로 구성 통합은 모노레포를 자동으로 이해합니다."
  }, {
    "heading": "",
    "content": "Vercel에 Turborepo를 배포하려면 새 프로젝트를 생성하고 코드를 가져옵니다. 프로젝트는 Vercel Remote Cache를 사용하기 위한 올바른 설정으로 사전 구성됩니다."
  }, {
    "heading": "",
    "content": "Turborepo를 Vercel에 배포하는 방법에 대한 자세한 내용은 Vercel 문서를 방문하세요."
  }],
  "headings": []
};
import __img0 from "./../../../../public/images/docs/turborepo-x-vercel.png";
export const toc = [];
function _createMdxContent(props) {
  const _components = {
    a: "a",
    img: "img",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: _jsx(_components.img, {
        alt: "",
        placeholder: "blur",
        src: __img0
      })
    }), "\n", _jsx(_components.p, {
      children: "Vercel의 Turborepo와의 제로 구성 통합은 모노레포를 자동으로 이해합니다."
    }), "\n", _jsxs(_components.p, {
      children: ["Vercel에 Turborepo를 배포하려면 ", _jsx(_components.a, {
        href: "https://vercel.com/new",
        children: "새 프로젝트를 생성"
      }), "하고 코드를 가져옵니다. 프로젝트는 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/monorepos/remote-caching",
        children: "Vercel Remote Cache"
      }), "를 사용하기 위한 올바른 설정으로 사전 구성됩니다."]
    }), "\n", _jsxs(_components.p, {
      children: ["Turborepo를 Vercel에 배포하는 방법에 대한 자세한 내용은 ", _jsx(_components.a, {
        href: "https://vercel.com/docs/concepts/monorepos/turborepo",
        children: "Vercel 문서를 방문"
      }), "하세요."]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
